
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sitemap/city/[slug]",
      function () {
        return require("private-next-pages/sitemap/city/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sitemap/city/[slug]"])
      });
    }
  